<slick-dialog key="DIALOG_SITE_LOG" header="Site Log — Fleet Checklist" width="1100" #siteLogDialog (onClose)="closeDialog()">
	<site-log-checklist-edit *ngIf="isOpen && customerId"
		[customerId]="customerId"
		[jobId]="jobId"
		[appointmentId]="appointmentId"
		(onClose)="closeDialog()"
		(onSaved)="onSaved.emit()"></site-log-checklist-edit>
</slick-dialog>
